// extracted by mini-css-extract-plugin
export var bodySections = "_9n-8";
export var gray = "_9n-7";
export var green = "_9n-4";
export var iconContainer = "_9n-9";
export var iconWidgetContainer = "_9n-1";
export var phoneIcon = "_9n-2";
export var red = "_9n-5";
export var statusDot = "_9n-3";
export var widgetContainer = "_9n-0";
export var yellow = "_9n-6";